import React, { useContext, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";

const Modals = () => {
  useEffect(() => {
    const observer = new MutationObserver((mutationsList) => {
      if (!document.querySelectorAll(".BottomSheet")[0]) {
        document.querySelectorAll("html")[0].style.overflowY = "auto";
      }
    });
    observer.observe(document, { subtree: true, childList: true });
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <>
      {/* {loading && <Loader />} */}
      {/* <Alert /> */}
    </>
  );
};

export default Modals;
